<template>
  <div class="dt-details2">
    <div class="dt-details--header">
      <div   class="title" v-if="invoiceProjectDetails && invoiceProjectDetails.invoice_project">
        {{invoiceProjectDetails.invoice_project.invoice_project_name || ''}}
      </div>
    </div>
    <!-- <div class="dt-details--body">
      <div class="dt-details--col">
        <div class="dt-details--row">
          <div class="dt-details--label">{{$t('invoice_project_name')}}</div>
          <div class="dt-details--value" v-if="invoiceProjectDetails">
            <div>{{invoiceProjectDetails.invoice_project.invoice_project_name}}</div>
          </div>
        </div>
        <div class="dt-details--row">
          <div class="dt-details--label">{{$t('country')}}</div>
          <div class="dt-details--value" v-if="invoiceProjectDetails">
            <div>{{invoiceProjectDetails.invoice_project.country}}</div>
          </div>
        </div>
      </div>
      <div class="dt-details--col">
        <div class="dt-details--row">
          <div class="dt-details--label">{{$t('company_name')}}</div>
          <div class="dt-details--value" v-if="invoiceProjectDetails">
            <div>{{invoiceProjectDetails.invoice_project.company_name}}</div>
          </div>
        </div>
        <div class="dt-details--row">
          <div class="dt-details--label">{{$t('paypal_email')}}</div>
          <div class="dt-details--value" v-if="invoiceProjectDetails">
            <div>{{invoiceProjectDetails.invoice_project.paypal_email}}</div>
          </div>
        </div>
      </div>
      <div class="dt-details--col">
        <div class="dt-details--row">
          <div class="dt-details--label">{{$t('vat_rate1')}}</div>
          <div class="dt-details--value" v-if="invoiceProjectDetails">
            <div>{{invoiceProjectDetails.invoice_project.vat_rate1}}</div>
          </div>
        </div>
        <div class="dt-details--row">
          <div class="dt-details--label">{{$t('vat_rate2')}}</div>
          <div class="dt-details--value" v-if="invoiceProjectDetails">
            <div>{{invoiceProjectDetails.invoice_project.vat_rate2}}</div>
          </div>
        </div>
      </div>
      <div class="dt-details--col">
        <div class="dt-details--row">
          <div class="dt-details--label">{{$t('Last Modified')}}</div>
          <div class="dt-details--value" v-if="invoiceProjectDetails">
            <div>{{invoiceProjectDetails.invoice_project.last_modified}}</div>
          </div>
        </div>
        <div class="dt-details--row">
          <div class="dt-details--label">{{$t('Created')}}</div>
          <div class="dt-details--value" v-if="invoiceProjectDetails">
            <div>{{invoiceProjectDetails.invoice_project.created}}</div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    invoiceProjectDetails: {
      type: Object
    }
  }
};
</script>

<style lang="sass" scoped>
.dt-details--label
  padding-left: 5px
</style>
